/* eslint-disable new-cap */
import { Controller } from "@hotwired/stimulus"
import { debounce } from "lodash"
import flatpickr from "flatpickr"
import rangePlugin from "flatpickr/dist/plugins/rangePlugin"
import { datepickerLocales } from "../locales/datepicker"

export default class extends Controller {
  static values = {
    format: { type: String, default: "Y-m-d" },
    locale: { type: String, default: "pl" },
    range: { type: Boolean, default: false },
    endInput: String
  }

  connect() {
    console.log("picker")

    const options = {
      locale: {
        ...this.locale,
        firstDayOfWeek: 1
      },
      dateFormat: this.formatValue,
      allowInput: true
    }

    if (this.rangeValue) {
      options.plugins = [new rangePlugin({ input: this.endInputValue })]
    }

    this.picker = flatpickr(this.element, options)

    const handleInput = debounce(() => {
      const val = this.element.value.trim()
      try {
        const parsed = this.picker.parseDate(val, this.formatValue)

        if (parsed instanceof Date && !isNaN(parsed)) {
          const formatted = this.picker.formatDate(parsed, this.formatValue)
          if (val === formatted) {
            this.picker.setDate(parsed, true)
          }
        }
      } catch (err) {
      }
    }, 500)

    this.element.addEventListener("keyup", handleInput)
  }

  disconnect() {
    if (this.picker) {
      this.picker.destroy()
      this.picker = null
    }
  }

  get locale() {
    if (this.hasLocaleValue) {
      return datepickerLocales[this.localeValue] || {}
    }

    return nil
  }
}
